import { Outlet } from "react-router";

const InventoryManagementPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default InventoryManagementPage;
